exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.sau-bundle-card .icon-sau-dedicated[data-v-031a1355]:before {\n  content: \"\\E003\" !important;\n}\n.sau-bundle-card .sau-server-box header i[data-v-031a1355] {\n  line-height: 1rem;\n}\n.price-box .price[data-v-031a1355] {\n  font-size: 2rem !important;\n}", ""]);

// exports
